import React, { useState } from 'react';
import Popup from './PopUp';

const ActiveDrivers = ({ activeDrivers }) => {
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  const handleOnClick = (driver) => {
    setSelectedDriver(driver);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedDriver(null);
  };

  if (!activeDrivers || activeDrivers.length === 0) {
    return <div className="text-gray-600">No active drivers found.</div>;
  }

  return (
    <div className="p-6">

      <div className="overflow-x-auto bg-white">
        <table className="w-full bg-white border-collapse mt-5">
          <thead>
            <tr>
              <th className="text-left text-[14px] font-bold font-sans border-b border-[#efefef] py-[14px] px-5">Name</th>
              <th className="text-left text-[14px] font-bold font-sans border-b border-[#efefef] py-[14px] px-5">Email</th>
              <th className="text-left text-[14px] font-bold font-sans border-b border-[#efefef] py-[14px] px-5">Phone</th>
              <th className="text-left text-[14px] font-bold font-sans border-b border-[#efefef] py-[14px] px-5">Working Hours</th>
              <th className="text-left text-[14px] font-bold font-sans border-b border-[#efefef] py-[14px] px-5">Status</th>
            </tr>
          </thead>
          <tbody>
            {activeDrivers.map((driver) => (
              <tr
              key={driver.driverId}
              className={`cursor-pointer font-sans hover:bg-gray-100 ${
                driver.isCurrentlyActive ? 'text-black' : 'text-gray-400'
              }`}
              onClick={() => handleOnClick(driver)}
              >
                <td className="py-[14px] px-5">
                  <span className="inline-block w-[25px] h-[25px] rounded-full bg-[#79c6e9] text-white text-center align-middle leading-[25px] text-[14px] mr-[10px]">
                    {driver.name.charAt(0).toUpperCase()}
                  </span>
                  {driver.name}
                </td>
                <td className="py-[14px] px-5 text-[14px]">{driver.email}</td>
                <td className="py-[14px] px-5 text-[14px]">{driver.phone}</td>
                <td className="py-[14px] px-5 text-[14px]">{driver.workingHours}</td>
                <td className="py-[14px] px-5 text-[14px]">
                  {driver.workingHours[1] >= 5 ? 'Full Day' : 'Half Day'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showPopup && <Popup selectedDriver={selectedDriver} closePopup={closePopup} />}
    </div>
  );
};

export default ActiveDrivers;